import { Texture } from './Texture';
import { Context } from '../context/Context';

export class CubeMapTexture extends Texture {
  public override get is2d(): boolean {
    return false;
  }

  public override get isCube(): boolean {
    return true;
  }

  protected override setMips(ctx: Context, width: number, height: number): boolean {
    const gl = ctx.gl;

    if (this.isPowerOf2(width) && this.isPowerOf2(height)) {
      gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
      return true;
    } else {
      // None power of two, so no mips
      // set the filtering so we don't need mips
      gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

      return false;
    }
  }

  protected getSideMapping(ctx: Context) {
    const gl = ctx.gl;
    return [
      { reference: 'posx', glCubeMapSide: gl.TEXTURE_CUBE_MAP_POSITIVE_X },
      { reference: 'negx', glCubeMapSide: gl.TEXTURE_CUBE_MAP_NEGATIVE_X },
      { reference: 'posy', glCubeMapSide: gl.TEXTURE_CUBE_MAP_POSITIVE_Y },
      { reference: 'negy', glCubeMapSide: gl.TEXTURE_CUBE_MAP_NEGATIVE_Y },
      { reference: 'posz', glCubeMapSide: gl.TEXTURE_CUBE_MAP_POSITIVE_Z },
      { reference: 'negz', glCubeMapSide: gl.TEXTURE_CUBE_MAP_NEGATIVE_Z },
    ];
  }

  public static override fromWebGlTexture(texture: WebGLTexture): CubeMapTexture {
    let t = new CubeMapTexture();
    t.glTexture = texture;

    return t;
  }
}
